import React from 'react';
import { store } from '../../store'
import { employerTypes } from './actions'


const _initialState = {
    isFetching: false,
    employers: {}, 
}


export function employers(state=_initialState, action) {
    switch(action.type) {


        case employerTypes.REMOVE_EMPLOYER:
            state = {...state}
            delete state.employers[action.customerId][action.employerId]
            return state

        case employerTypes.CLEAR_VIDT_EMPLOYERS:
            state = {...state}
            let oldEmployers = state.employers[action.customerId] || {}
            let newEmployers = {}
            Object.keys(oldEmployers).map(employerId => {
                if (oldEmployers[employerId].employer.contractType !== 'VIDT') {
                    newEmployers[employerId] = oldEmployers[employerId]
                }
            })
            state.employers[action.customerId] = newEmployers
            return state

        case employerTypes.SET_EMPLOYER:
            state = {...state}

            if (state.employers[action.customerId] === undefined) {
                state.employers[action.customerId] = {}
                state.employers[action.customerId][action.employer.OrgId] = { startDate: action.startDate, employer: action.employer}
            } else {
                state.employers[action.customerId][action.employer.OrgId] = { startDate: action.startDate, employer: action.employer}
            }
            
            return state
        
        default:
            return state
    }
}